module.exports = require('../../full/object/keys');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/keys.js
// module id = 1277
// module chunks = 25